/**
 * Generic script-deferral utility.
 *
 * Two opt-in loading strategies for otherwise-inert script placeholders:
 *   <script class="defer-load" data-src="..."></script>
 *     - activated on window 'load'.
 *   <script class="interaction-load" data-src="..."></script>
 *     - activated on the visitor's first interaction (scroll, mousemove,
 *       touchstart, keydown, click), or after a 5000ms idle fallback,
 *       whichever comes first.
 *
 * Supported attributes on the placeholder tag:
 *   data-src    (required) - becomes the real script's src.
 *   id          - carried over to the real script tag, if present.
 *   data-async  - "true" sets async on the real script tag.
 *   data-onload - name of a function on `window` invoked once the real
 *                 script's load event fires.
 *
 * Each placeholder is only ever activated once (data-loaded flag).
 */
(function () {
  'use strict';

  var INTERACTION_EVENTS = ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'];
  var INTERACTION_FALLBACK_DELAY = 5000;

  function activate(el) {
    if (el.getAttribute('data-loaded') === 'true') return;
    var src = el.getAttribute('data-src');
    if (!src) return;
    el.setAttribute('data-loaded', 'true');

    var script = document.createElement('script');
    script.src = src;

    var id = el.getAttribute('id');
    if (id) script.id = id;

    if (el.getAttribute('data-async') === 'true') {
      script.async = true;
    }

    var onloadFnName = el.getAttribute('data-onload');
    if (onloadFnName) {
      script.addEventListener('load', function () {
        if (typeof window[onloadFnName] === 'function') {
          window[onloadFnName]();
        }
      });
    }

    el.parentNode.replaceChild(script, el);
  }

  function activateAll(selector) {
    var elements = document.querySelectorAll(selector);
    for (var i = 0; i < elements.length; i++) {
      activate(elements[i]);
    }
  }

  // --- defer-load: window 'load' ---
  window.addEventListener('load', function () {
    activateAll('script.defer-load[data-src]');
  });

  // --- interaction-load: first interaction, or idle fallback ---
  var interactionTriggered = false;
  var fallbackTimer;

  function triggerInteractionLoad() {
    if (interactionTriggered) return;
    interactionTriggered = true;
    clearTimeout(fallbackTimer);
    INTERACTION_EVENTS.forEach(function (evt) {
      window.removeEventListener(evt, triggerInteractionLoad, { passive: true });
    });
    activateAll('script.interaction-load[data-src]');
  }

  fallbackTimer = setTimeout(triggerInteractionLoad, INTERACTION_FALLBACK_DELAY);
  INTERACTION_EVENTS.forEach(function (evt) {
    window.addEventListener(evt, triggerInteractionLoad, { passive: true, once: true });
  });

  window.PerformanceLoader = {
    loadDeferred: function () { activateAll('script.defer-load[data-src]'); },
    loadInteraction: triggerInteractionLoad
  };
})();
